module.exports = __webpack_public_path__ + "static/img/tunnel-text-3.ffc4ec7f.png";